import { createSelector } from 'reselect'

const getCountries = createSelector(
  state => state.app.config,
  config => config.countries || []
)

const getNationalities = createSelector(
  state => state.app.config,
  config => config.nationalities || []
)

const getReasons = createSelector(
  state => state.app.config,
  config => config.reasons || []
)


const propertyRemovedReasons = createSelector(
  getReasons,
  reasons => reasons.filter(reason => reason.type === 'PROPERTY_REMOVED')
)

const propertyReviewReasons = createSelector(
  getReasons,
  reasons => reasons.filter(reason => reason.type === 'REVIEW')
)

const crmSites = createSelector(
  state => state.app.config,
  config => config.sites || []
)

const nationalPortals = createSelector(
  crmSites,
  portals => portals.filter(
    portal =>
      portal.visibility === 'NATIONAL' &&
      portal.category !== 'AGGREGATOR' &&
      portal.category !== 'MLS' &&
      portal.category !== 'PARTNER'
  )
)

const internationalPortals = createSelector(
  crmSites,
  portals => portals.filter(
    portal =>
      portal.visibility === 'INTERNATIONAL' &&
      portal.category !== 'AGGREGATOR' &&
      portal.category !== 'MLS' &&
      portal.category !== 'PARTNER'
  )
)

const aggregatorPortals = createSelector(
  crmSites,
  portals => portals.filter(
    portal => portal.category === 'AGGREGATOR'
  )
)

const mlsPortals = createSelector(
  crmSites,
  portals => portals.filter(
    portal => portal.category === 'MLS'
  )
)

const partnerPortals = createSelector(
  crmSites,
  portals => portals.filter(
    portal => portal.category === 'PARTNER'
  )
)

const getScoringTraits = createSelector(
  state => state.app.config,
  config => config.traits || []
)

const getBrokerTypes = createSelector(
  state => state.app.config,
  config => config.brokerTypes || []
)

const planCodes = createSelector(
  state => state.app.config,
  config => config.planCodes || []
)

const getValidYalsAmenityNames = createSelector(
  state => state.app.config,
  config => {
    const yalsMappings = config.yalsMappings || { amenities: {}}
    return Object.keys(yalsMappings.amenities)
  }
)


export {
  getCountries,
  getNationalities,
  getReasons,
  propertyRemovedReasons,
  propertyReviewReasons,
  crmSites,
  nationalPortals,
  internationalPortals,
  aggregatorPortals,
  mlsPortals,
  partnerPortals,
  getScoringTraits,
  getBrokerTypes,
  planCodes,
  getValidYalsAmenityNames,
}
